import { issueBadgeClasses } from './badgeBase';
import { clsx } from 'clsx';
import { HugeiconsIcon } from '@hugeicons/react';
import { Flag03Icon } from '@hugeicons/core-free-icons';
import type { TicketSeverity } from '@overlayqa/shared';

// Filled pill matching the Type ("A11y") and Status ("Open") badges: a
// severity-tinted background + severity-colored text/icon. Shares the
// TypeBadge/StatusBadge base: small control box, compact corner and micro role.
const SEVERITY_CONFIG: Record<string, { label: string; bg: string; text: string }> = {
  critical: { label: 'Critical', bg: 'bg-[var(--color-severity-critical-bg)]', text: 'text-[var(--color-severity-critical)]' },
  high: { label: 'High', bg: 'bg-[var(--color-severity-high-bg)]', text: 'text-[var(--color-severity-high)]' },
  medium: { label: 'Medium', bg: 'bg-[var(--color-severity-medium-bg)]', text: 'text-[var(--color-severity-medium)]' },
  low: { label: 'Low', bg: 'bg-[var(--color-severity-low-bg)]', text: 'text-[var(--color-severity-low)]' },
};

interface SeverityBadgeProps {
  severity: TicketSeverity;
}

export function SeverityBadge({ severity }: SeverityBadgeProps) {
  const config = SEVERITY_CONFIG[severity] ?? SEVERITY_CONFIG.low;
  return (
    <span className={clsx(issueBadgeClasses, config.bg, config.text)}>
      <HugeiconsIcon
        icon={Flag03Icon}
        size={10}
        strokeWidth={2}
        color="currentColor"
        className="w-[10px] h-[10px] flex-shrink-0"
        aria-hidden="true"
      />
      {config.label}
    </span>
  );
}
